import { Product } from "./product";
import { SystemField } from "./system-field";

export class Basket extends SystemField{

    products_id?:string;
    qty?:number;
    owner_id?:string;
    basket_type?:string;
    parent_baskets_id?:string;
    sale_price?: number;

    //relationship fields
    product?:Product;
}
